/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { UserAvatarFragmentDoc } from '../../users/UserAvatar.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DocumentViewerAvatarsQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']['input']>;
}>;


export type DocumentViewerAvatarsQuery = { organisationMemberships: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationMembershipsConnection', edges: Array<{ __typename: 'OrganisationMembershipEdge', node: { __typename: 'User', id: string, fullname: string, firstname: string, familyname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, url: string } | null } }> } };

export type ActiveDocumentViewersChangedSubscriptionVariables = Types.Exact<{
  documentId: Types.Scalars['ID']['input'];
  documentType: Types.ActiveDocumentViewersType;
}>;


export type ActiveDocumentViewersChangedSubscription = { activeDocumentViewersChanged: Array<string> };


export const DocumentViewerAvatarsDocument = gql`
    query DocumentViewerAvatars($ids: [ID!]!) {
  organisationMemberships(
    limit: 100
    sorting: [{column: firstname, direction: asc}]
    filters: {ids: $ids}
  ) {
    ... on OrganisationMembershipsConnection {
      edges {
        node {
          id
          fullname
          ...UserAvatar
        }
      }
    }
  }
}
    ${UserAvatarFragmentDoc}`;

/**
 * __useDocumentViewerAvatarsQuery__
 *
 * To run a query within a React component, call `useDocumentViewerAvatarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentViewerAvatarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentViewerAvatarsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDocumentViewerAvatarsQuery(baseOptions: Apollo.QueryHookOptions<DocumentViewerAvatarsQuery, DocumentViewerAvatarsQueryVariables> & ({ variables: DocumentViewerAvatarsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentViewerAvatarsQuery, DocumentViewerAvatarsQueryVariables>(DocumentViewerAvatarsDocument, options);
      }
export function useDocumentViewerAvatarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentViewerAvatarsQuery, DocumentViewerAvatarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentViewerAvatarsQuery, DocumentViewerAvatarsQueryVariables>(DocumentViewerAvatarsDocument, options);
        }
export function useDocumentViewerAvatarsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocumentViewerAvatarsQuery, DocumentViewerAvatarsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentViewerAvatarsQuery, DocumentViewerAvatarsQueryVariables>(DocumentViewerAvatarsDocument, options);
        }
export type DocumentViewerAvatarsQueryHookResult = ReturnType<typeof useDocumentViewerAvatarsQuery>;
export type DocumentViewerAvatarsLazyQueryHookResult = ReturnType<typeof useDocumentViewerAvatarsLazyQuery>;
export type DocumentViewerAvatarsSuspenseQueryHookResult = ReturnType<typeof useDocumentViewerAvatarsSuspenseQuery>;
export type DocumentViewerAvatarsQueryResult = Apollo.QueryResult<DocumentViewerAvatarsQuery, DocumentViewerAvatarsQueryVariables>;
export const ActiveDocumentViewersChangedDocument = gql`
    subscription ActiveDocumentViewersChanged($documentId: ID!, $documentType: ActiveDocumentViewersType!) {
  activeDocumentViewersChanged(
    documentId: $documentId
    documentType: $documentType
  )
}
    `;

/**
 * __useActiveDocumentViewersChangedSubscription__
 *
 * To run a query within a React component, call `useActiveDocumentViewersChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useActiveDocumentViewersChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveDocumentViewersChangedSubscription({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useActiveDocumentViewersChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ActiveDocumentViewersChangedSubscription, ActiveDocumentViewersChangedSubscriptionVariables> & ({ variables: ActiveDocumentViewersChangedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ActiveDocumentViewersChangedSubscription, ActiveDocumentViewersChangedSubscriptionVariables>(ActiveDocumentViewersChangedDocument, options);
      }
export type ActiveDocumentViewersChangedSubscriptionHookResult = ReturnType<typeof useActiveDocumentViewersChangedSubscription>;
export type ActiveDocumentViewersChangedSubscriptionResult = Apollo.SubscriptionResult<ActiveDocumentViewersChangedSubscription>;